import { Application } from '@hotwired/stimulus'

declare global {
  interface Window {
    Stimulus: Application
  }
}

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
// As Window: a file importing the 'stimulus' package adds its UMD namespace to the type of window.Stimulus
;(window as Window).Stimulus = application

export { application }
